import LogoImg from "@/../../public/images/pelorus-logo.svg";
import forgotPasswordsystem from "@/../../public/images/forgotPassword.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AuthFooterScreen from "../../../component/layout/authfooter";

import { AppRoute } from "../../../router/routerConstants";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import * as yup from "yup";
import { ValidationCons } from "../../../validation/validationConstant";
import { forgetPasswordApi } from "../../../service/apis/auth.api";
import { useFormik } from "formik";
import { showError } from "../../../utils/Common";

const ForgotPasswordScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const [, setLoading] = useState(false);
  const { state } = useLocation();

  const forgetPasswordFormik = useFormik({
    initialValues: {
      email: state.email || "",
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .trim()
        .email(ValidationCons.IS_EMAIL)
        .required(ValidationCons.EMAIL_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        const bodyData = {
          email: values.email,
        };
        const response = await forgetPasswordApi(bodyData);

        let success =
          response && response.message && typeof response.message === "string"
            ? /Sent/.test(response.message) && /email/.test(response.message)
            : false;
        if (success) {
          NavigateTo(AppRoute.VERIFY_FORGET_PASS, false, bodyData);
        } else {
          showError(response?.message);
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.message);
      }
    },
  });
  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                <a href="/">
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd pb-0">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={forgotPasswordsystem} alt="logo"/>
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder forgotPassword-holder">
                  <h1>Forgot Password</h1>
                  <p>
                    Please enter your email address to reset your password. You
                    will receive an email with instructions on how to reset your
                    password.
                  </p>
                  <div className="login-form-area forgotPassword-form  mt-5">
                    <Form onSubmit={forgetPasswordFormik.handleSubmit}>
                      <h3>Your Email Address</h3>
                      <p>Please enter your email address.</p>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your registered email address"
                          name="email"
                          onChange={forgetPasswordFormik.handleChange}
                          onBlur={forgetPasswordFormik.handleBlur}
                          value={forgetPasswordFormik.values.email}
                          isInvalid={
                            !!forgetPasswordFormik.errors.email &&
                            Boolean(forgetPasswordFormik.touched.email)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {typeof forgetPasswordFormik.errors.email ===
                            "string" && forgetPasswordFormik.errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <div className="mt-5">
                        <Button
                          className="btn w-100 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />
    </>
  );
};
export default ForgotPasswordScreen;
